module.exports = __webpack_public_path__ + "img/home-03.48d78281.webp";